import { Item as RadixItem } from '@radix-ui/react-dropdown-menu';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

type MobileMenuItemProps = Omit<
  ComponentPropsWithoutRef<typeof RadixItem>,
  'onSelect' | 'asChild'
>;

/**
 * Registers a row of the mobile drill-down panel with the Radix menu, wrapping
 * the row element passed as its single child.
 *
 * The panel builds its own rows rather than reusing the desktop markup, but
 * `Menu.Content` only moves focus between rows that Radix knows about, so every
 * focusable row has to go through here to take part in keyboard navigation.
 * None of them commit a selection the way a desktop item does - closing and
 * drilling down are driven by each row's own click handler - which is why
 * Radix's auto-close on select is always cancelled.
 * @internal
 */
export const MobileMenuItem = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  MobileMenuItemProps
>((props, forwardedRef) => (
  <RadixItem
    {...props}
    ref={forwardedRef}
    onSelect={(event) => event.preventDefault()}
    asChild
  />
));

(
  MobileMenuItem as typeof MobileMenuItem & { displayName: string }
).displayName = 'MobileMenuItem';
